import { L10N } from '../Checkout.l10n';

const POS_ERROR_L10N = {
  AUTHENTICATION_FAILED: L10N.NOTIFICATION_POS_PROCESSING_ERROR,
  AUTHENTICATION_NEEDED: L10N.NOTIFICATION_POS_PROCESSING_ERROR,
  AUTHENTICATION_REQUIRED: L10N.NOTIFICATION_POS_PROCESSING_ERROR,
  CARD_DECLINED: L10N.NOTIFICATION_POS_CARD_DECLINED,
  GATEWAY_ERROR: L10N.NOTIFICATION_POS_CONTACT_PROPERTY,
  INSUFFICIENT_FUNDS: L10N.NOTIFICATION_POS_INSUFFICIENT_FUNDS,
  MERCHANT_ERROR: L10N.NOTIFICATION_POS_CONTACT_PROPERTY,
  SUSPECT_FRAUD: L10N.NOTIFICATION_POS_CONTACT_PROPERTY,
  TIMEOUT: L10N.NOTIFICATION_POS_PROCESSING_ERROR,
  UNKNOWN: L10N.NOTIFICATION_POS_CONTACT_PROPERTY,
  USER_CANCELLED: L10N.NOTIFICATION_POS_USER_CANCELLED,
};

const getPosErrorL10n = (messageToClient) => POS_ERROR_L10N[messageToClient] || L10N.NOTIFICATION_UNKNOWN_POS_ERROR;

export { getPosErrorL10n };
